export default "__VITE_ASSET__BK7LDIWa__"